export const HELP_EMAIL = "support@picturebooks.ai"
